import { Route } from '@angular/router';
import { inject } from '@angular/core';
import { RouteIds } from '../../../types';
import { ExtrasStepComponent } from './extras-step.component';
import { StepResolverService } from '../../../services';

export const extrasStepRoute: Route = {
  path: RouteIds.extras,
  resolve: { step: () => inject(StepResolverService).resolve(RouteIds.extras) },
  component: ExtrasStepComponent,
};
